<i18n
  src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>

<template>
  <div>
    <h1 class="page-title">
      <i class="fa-solid fa-pallet-boxes"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>
    <div class="flex flex-row justify-end">
      <template v-if="!intermediate_process">
        <button
          type="button"
          @click.prevent="goToUploadPackingList()"
          class="btn-white"
        >
          <i class="fa-solid fa-cloud-upload"></i><span class="space-icon"></span
          >{{ $t("labels.upload_packing_list") }}
        </button>
        <span class="space-actions" />
        <button
          type="button"
          @click.prevent="downloadFormatXlsx"
          class="btn-white"
        >
          <i class="fa-solid fa-download"></i><span class="space-icon"></span
          >{{ $t("labels.download_format") }}
        </button>
        <span class="space-actions" />
      </template>
      <tabs-download-buttons-packing-list
        :container_code="this.container.container_code"
        :container_id="this.container_id"
      />
      <button
        type="button"
        v-if="!intermediate_process && can_add_package_group"
        @click.prevent="goToNew()"
        class="btn-white"
      >
        <i class="fa-solid fa-plus"></i><span class="space-icon"></span
        >{{ $t("labels.new_button") }}
      </button>
    </div>
    <div class="mt-8">
      <div class="inline-block min-w-full">
        <div class="flex flex-wrap">
          <div
            v-for="col in cols"
            :key="col"
            :class="[card_width_class, 'divide-y divide-slate-200']"
          >
            <div
              v-for="row in rows"
              :key="row"
              :class="[col == cols ? '' : 'border-r', 'border-gray-200']"
            >
              <package-group-card
                v-if="getPackageGroup(row, col)"
                :intermediate_process="intermediate_process"
                :rounded_class="cardRoundedClass(col, row)"
                :package_group="getPackageGroup(row, col)"
                @destroy="remove($event)"
              />
              <empty-card
                v-else
                :intermediate_process="intermediate_process"
                :row="row"
                :col="col"
                :rounded_class="cardRoundedClass(col, row)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UniqFinalPackingListRequester from "@/views/agro_exporter/requesters/production/uniq_final_packing_list.js";
import PackageGroupCard from "@/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/PackageGroupCard.vue";
import EmptyCard from "@/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/pallets/EmptyCard.vue";
import TabsDownloadButtonsPackingList from "./DownloadButtonsPackingList.vue";
import TabsMixin from "@/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/mixin.js"

export default {
  name: "PalletsTab",
  components: {
    PackageGroupCard,
    EmptyCard,
    TabsDownloadButtonsPackingList
  },
  mixins: [TabsMixin],
  props: {
    container: { type: Object },
    package_groups: {
      type: Array,
      required: true
    }
  },
  emits: ["update:packages-groups"],
  data() {
    return {
      downloading_rep: false,
      pallet_charging: {}
    };
  },
  computed: {
    action_btn_class: function () {
      return "inline-flex justify-center py-2 px-4 border shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2";
    },
    card_width_class: function () {
      let cols = String(this.cols ?? 1);
      let width_class = `w-1/${cols}`;
      return `${width_class} lg:${width_class}`;
    },
    pallet_action_btn_class: function () {
      return `${this.action_btn_class} border-[#0d1f3c] text-[#0d1f3c] hover:text-white hover:bg-slate-800 focus:ring-[#5c7a2e] w-full lg:w-1/5`;
    },
    pallet_destroy_action_btn_class: function () {
      return `${this.action_btn_class} bg-red-700 border border-red-700 text-white hover:bg-red-700 focus:ring-red-500 w-full lg:w-1/5`;
    },
    any_package_group: function () {
      if (this.package_groups) return this.package_groups.length > 0;
      return false;
    },
    cols: function () {
      return this.container?.cols_package_groups ?? 1;
    },
    rows: function () {
      return this.container?.rows_package_groups ?? 1;
    },
    max_package_groups: function () {
      return this.container?.max_package_groups ?? 0;
    },
    can_add_package_group: function () {
      return this.package_groups.length < this.max_package_groups;
    }
  },
  methods: {
    cardRoundedClass: function (col, row) {
      let def_class =
        "relative group bg-white p-2 focus-within:ring-2 focus-within:ring-inset focus-within:ring-[#5c7a2e]";
      if (col == 1 && row == 1) def_class += " rounded-tl-lg";
      if (col == this.cols && row == 1) def_class += " sm:rounded-tr-lg";
      if (col == 1 && row == this.rows) def_class += " sm:rounded-bl-lg";
      if (col == this.cols && row == this.rows) def_class += " rounded-br-lg";
      return def_class;
    },
    changeCharging: function (package_group) {
      this.pallet_charging[package_group.id] =
        !this.pallet_charging[package_group.id];
    },
    getPackageGroup: function (row, col) {
      return this.package_groups.find(
        package_group =>
          package_group.row_position === row &&
          package_group.col_position === col
      );
    },
    goToNew: function () {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_new_package_group_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    goToUploadPackingList: function () {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_upload_packing_list_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    remove: function (package_group) {
      this.$emit(
        "update:packages-groups",
        this.package_groups.filter(item => item.id !== package_group.id)
      );
    },
    replacePackageGroup: function (package_group, new_package_group) {
      this.$emit(
        "update:packages-groups",
        this.package_groups.map(item =>
          item.id === package_group.id ? new_package_group : item
        )
      );
    },
    downloadFormatXlsx: async function () {
      try {
        let response = await UniqFinalPackingListRequester.downloadFormatXlsx(
          this.container_id
        );

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `Formato Packing List.xlsx`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
    }
  }
};
</script>
